import React, { useEffect, useState } from "react";
import { Button, Checkbox, Col, Input, Row, Slider, Toast, Tooltip, DatePicker } from "@kaleyra/emmy";
import Styles from './index.module.scss';
import { useTranslation } from "react-i18next";
import InfoIcon from '../../../../assets/info-icon-light.svg';
import { isEmpty } from "lodash";
import { useLocation } from "react-router-dom";
import { validateTxtlyUrl } from "../../../../utils";
import { ReferecedValueFor } from "../bulkUrlShortener";
import moment,{ Moment } from "moment";

export type MapStateType = {
    viewData: any;
    isEdit: any;
};

export type DispatchPropsType = {
    onEdit: (formData: any, callback: (resp: any, flag: boolean) => void) => void;
    onClose: () => void;
    onLoad: (bulkid: string, filters?: any, SearchStr?: string) => void;
};


const BulkEditForm: React.FC<MapStateType & DispatchPropsType> = ({
    onClose, isEdit, viewData, onEdit, onLoad }) => {
    const { t } = useTranslation();
    const isEditForm = isEdit.id;
    const {
        SearchStr,
        filters
    } = isEdit?.extraParam;
    const [originalUrl, setOriginalUrl] = useState<string>("");
    const [urlTitle, setUrlTitle] = useState<string>("");
    const textlyLabel = process.env.REACT_APP_TEXTLY_LABEL || "";
    const [slug, setSlug] = useState<string>("");
    const [callbackUrl, setCallbackUrl] = useState<string>("");
    const [trackUserStatus, setTrackUserStatus] = useState<boolean>(false);
    const { search } = useLocation();
    const match = search.match(/bulk_id=(.*)/);
    const referenceKey = match?.[1];
    const [bulkid, setBulkId] = useState<string|undefined>("");
    const [selecteddate, setSelectedDate] = useState<Moment|null>(null);

    useEffect(() => {
        if (isEdit.id) {
            const dataById = viewData.find((data: any) => data.id.toString() === isEdit.id.toString());
            setOriginalUrl(dataById?.url);
            setUrlTitle(dataById?.title);
            setSlug(dataById?.slug);
            setTrackUserStatus((dataById?.is_advanced === 1) ? true : false);
            setCallbackUrl(dataById?.callback_url);
            setSelectedDate(dataById?.expiry ? moment(new Date(dataById?.expiry)): null);
        }
        if (referenceKey) {
            let bulkid = ReferecedValueFor(referenceKey);
            if (typeof bulkid !== 'undefined') {
                setBulkId(bulkid)
            }
        }
    }, []);

    const formatPostData = (): FormData => {
        let formDataOb = new FormData();
        formDataOb.append('url', originalUrl);
        formDataOb.append('url_title', urlTitle);
        formDataOb.append('id', isEdit.id)
        formDataOb.append('appid', isEdit.extraParam.appid)
        if (!isEmpty(callbackUrl)) {
            formDataOb.append('callback_url', callbackUrl);
        }
        if(selecteddate){
            formDataOb.append('expiry', selecteddate?.format('YYYY-MM-DD HH:mm:ss'));
        }
        formDataOb.append('is_advanced', trackUserStatus ? "on" : "off");
        return formDataOb;
    }

    const handleSaveCallback = (response: any, flag: boolean) => {
        if (flag) {
            Toast(Boolean(isEditForm) ? `${t('BLD02002')}` : `${t('BLD02003')}`, "success");
            onLoad(bulkid || "", filters, SearchStr);
            onClose();
        } else {
            Toast(response.data?.message, "error")
        }
    }

    const handleFormSave = () => {
        const postRequestBody = formatPostData();
        onEdit(postRequestBody, handleSaveCallback);
    }

    const isTitleValid = (): boolean => {
        return urlTitle?.length !== 0 && urlTitle?.length <= 100;
    }

    const isSlugValid = (): boolean => {
        const slugRegex = /^[A-Za-z0-9-]*$/;
        const result = slug.match(slugRegex);
        return (slug?.length === 0 || (slug.length <= 10 && result !== null));
    }

    const isCallbackURLValid = (): boolean => {
        return callbackUrl === undefined || callbackUrl?.length === 0 || validateTxtlyUrl(callbackUrl);
    }

    const isFormValid = (): boolean => {
        return validateTxtlyUrl(originalUrl) && isSlugValid() && isTitleValid() && isCallbackURLValid()
    }

    const renderTooltipBody = () => {
        return (
            <div className={Styles.tooltipBodyWrapper}>
                <span>{t('BLD02004')}</span>
                <span>{t('BLD02005')}</span>
            </div>
        )
    }

    const renderFormBody = () => {
        return (
            <>
                <div>
                    <Input label={t('BLD02007')} placeholder={t('BLD02007')} value={urlTitle} onChange={(e: any) => setUrlTitle(e.target.value)} bottomLabelType={(urlTitle?.length === 0 || isTitleValid() ? "default" : "error")} />
                </div>
                <div>
                    <Input label={t('BLD02006')} placeholder={t('BLD02006')} value={originalUrl} onChange={(e: any) => setOriginalUrl(e.target.value)} bottomLabelType={(originalUrl?.length === 0 || validateTxtlyUrl(originalUrl)) ? "default" : "error"} />
                </div>
                {/* } */}
                <div>
                    <span className={Styles.formLabel}>{t('BLD02010')}</span>
                    <Row className={Styles.twoColumnFormRow}>
                        <Col gutter size={6}>
                            <Input label={t('BLD02008')} disabled placeholder={t('BLD02008')} value={textlyLabel} />
                        </Col>
                        <Col size={6}>
                            <Input label={t('BLD02009')} disabled={isEditForm} placeholder={t('BLD02009')}
                                suffix={<Tooltip title={renderTooltipBody()} placement="left"><img src={InfoIcon}></img></Tooltip>}
                                value={slug} onChange={(e: any) => setSlug(e.target.value)}
                                bottomLabelType={slug.length === 0 || isSlugValid() ? "default" : "error"} />
                        </Col>
                    </Row>
                </div>
                <div>
                    <Input label={t('BLD02011')} placeholder={t('BLD02011')} value={callbackUrl} onChange={(e: any) => setCallbackUrl(e.target.value)} bottomLabelType={isCallbackURLValid() ? "default" : "error"} />
                </div>
                <Row>
                    <Col size={12}>
                        <Checkbox label={t('BLD02012')} className={Styles.checkbox} checked={trackUserStatus} onChange={(event: any) => setTrackUserStatus(event.target.checked)} />
                    </Col>
                </Row>
                <div className={Styles.datePickerWrapper}>
					<div>{t('urlExpiryHeading')}</div>
					<DatePicker
						style={{ width: '100%' }}
						value={selecteddate}
						onChange={(date: any) => setSelectedDate(date)}
                        allowClear={isEdit.id ? false: true}
                        showToday={false}
						disabledDate={(date) => {
							return (
								date &&
								!(
									date >
										moment().add(1, 'day').startOf('day') &&
									date < moment().add(1, 'year').endOf('day')
								)
							);
						}}
					/>
					<div className={Styles.desc}>{t('urlExpiryDescption')}</div>
				</div>
                <div className={Styles.footerPosition}>
                    <Button type="tertiary" onClick={onClose}>
                        {t('mainCancel')}
                    </Button>
                    <Button type="primary" onClick={() => handleFormSave()} disabled={!isFormValid()}>
                        {t('mainSave')}
                    </Button>
                </div>
            </>
        );
    }

    return (
        <Slider
            containerId="root-modal"
            onClose={onClose}
            visibility={true}
            title={t('BLD02013')}
        >
            <div className={Styles.container}>
                {renderFormBody()}
            </div>
        </Slider>
    )
}

export default BulkEditForm;